import { Component, HostListener, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EstadoDescargaCertificadoStepperService } from '../../services/estado-descarga-certificado-stepper.service';
import { BASIC_CLIENT_INFO } from '@constants/data-service.constant';
import { StorageService } from '@services/storage/storage.service';
import { loadRemoteModule } from '@angular-architects/module-federation';
import { environment } from 'src/environments/environment';
import * as date from 'date-fns-tz';
import { ModalService } from '@services/modal/modal.service';
import { Router } from '@angular/router';
import { DATA_UPDATE, HOME_URL, PROFILE } from '@constants/url.constant';
import { GenericErrorOps } from '@shared/components/generic-error/interfaces/generic-error-ops.interface';
import { CONFIRM_SOLICITUD_ERROR } from '@constants/congelamiento-saldo';
import { DIAS_VIGENCIA_CERTIFICADO_OFERTAS } from '@constants/tramite-pension-constant';
import { CertificadoOfertaService } from '../../services/certificado-oferta.service';

@Component({
  selector: 'app-modal-descarga-certificado-ofertas',
  templateUrl: './modal-descarga-certificado-ofertas.component.html',
  styleUrls: ['./modal-descarga-certificado-ofertas.component.scss'],
  standalone: false,
})
export class ModalDescargaCertificadoOfertasComponent implements OnInit, OnDestroy {
  pasos = [
    { id: 1, title: 'Consideraciones', subTitle: 'Actualización de datos', titleMobile: 'Consideraciones' },
    { id: 2, title: 'Validación de identidad', subTitle: 'Ingreso de claves', titleMobile: 'Validación de identidad' },
    { id: 3, title: 'Descarga de certificado', subTitle: 'Obtener certificado', titleMobile: 'Descarga de certificado' },
    { id: 4, title: 'Confirmación de descarga', subTitle: 'Descarga exitosa', titleMobile: 'Confirmación de descarga' },
  ];

  datosPersonales = { telefono: '', email: '' };

  pasoActual = 1;
  isResponsive: boolean = false;
  @ViewChild('microfrontContainer', { read: ViewContainerRef }) microfrontContainer!: ViewContainerRef;
  tipoValidacionSeguridad: string | null = null;
  fechaDescargaCertificado: Date = date.zonedTimeToUtc(new Date(), 'America/Santiago');
  loading = false;
  errorServiceDescargaCertificado = false;
  public errorOps: GenericErrorOps;
  attempt: boolean = false;
  nAttempts: number = 0;

  constructor(
    private readonly modalCtrl: ModalController,
    private readonly descargaCertificadoStepper: EstadoDescargaCertificadoStepperService,
    private readonly storageService: StorageService,
    private readonly modalService: ModalService,
    private readonly router: Router,
    private readonly certificadoOfertaService: CertificadoOfertaService,

  ) {
    this.descargaCertificadoStepper.setStepCurrent(1);
    this.isResponsive = window.innerWidth < 840;
  }

  async ngOnInit() {
    this.errorOps = CONFIRM_SOLICITUD_ERROR;

    globalThis.addEventListener('microfront:validacionExitosa', this.onValidacionExitosa.bind(this));
    globalThis.addEventListener('microfront:closeAllModals', this.onCerrar.bind(this));

    const infoClient = await this.storageService.get(BASIC_CLIENT_INFO);
    this.datosPersonales = { telefono: infoClient.cellphoneNumber, email: infoClient.email };

    this.tipoValidacionSeguridad = await this.storageService.get('tipoValidacionSeguridad');

    if (this.pasoActual === 3) {
      await this.cargarMicrofront();
    }
  }

  ngOnDestroy() {
    globalThis.removeEventListener('microfront:validacionExitosa', this.onValidacionExitosa.bind(this));
    globalThis.removeEventListener('microfront:closeAllModals', this.onCerrar.bind(this));
  }

  private onValidacionExitosa() {
    this.pasoActual = 3;
    this.descargaCertificadoStepper.setStepCurrent(this.pasoActual);
  }

  private async onCerrar() {
    let modal = await this.modalCtrl.getTop();
    while (modal) {
      await this.modalCtrl.dismiss();
      modal = await this.modalCtrl.getTop();
    }
  }

  cerrar() {
    if (this.pasoActual === 4) {
      sessionStorage.removeItem('microfront_embebido');
      this.modalCtrl.dismiss();
    } else {
      this.modalSalirSinDescargar();
    }
  }

  private modalSalirSinDescargar(tipoElemento: string = '') {
    const dataModal = {
      logo: '../assets/icons/error_32px.svg',
      title: '¿Deseas salir sin descargar el certificado?',
      subtitle: 'Al salir deberás comenzar de nuevo para obtener el Certificado de Ofertas SCOMP.',
      primaryButtonText: 'Salir',
      secondaryButtonText: 'Continuar descarga',
      primaryButtonCallback: () => {
        sessionStorage.removeItem('microfront_embebido');
        void this.onCerrar();
        if (tipoElemento === 'link') {
          this.router.navigate([DATA_UPDATE, HOME_URL, PROFILE]);
        }
      },
      secondaryButtonCallback: () => this.modalService.closeModal(),
      closeButtonCallback: () => { },
    }
    void this.modalService.openGenericModalWithSubtitle(dataModal);
  }

  async avanzar() {
    if (this.pasoActual < this.pasos.length) {
      this.pasoActual++;
      this.descargaCertificadoStepper.setStepCurrent(this.pasoActual);

      if (this.pasoActual === 2) {
        setTimeout(() => this.cargarMicrofront(), 0);
      }
    } else {
      sessionStorage.removeItem('microfront_embebido');
      this.modalCtrl.dismiss({ confirmado: true });
    }
  }

  @HostListener("window:resize", ["$event"])
  onWindowResize() {
    this.isResponsive = globalThis.innerWidth < 840;
  }

  keyPressClose(event: KeyboardEvent) {
    if (event.key === ' ' || event.key === 'Enter') {
      this.cerrar();
    }
  }

  async cargarMicrofront() {
    if (!this.microfrontContainer) return;

    sessionStorage.setItem('microfront_embebido', 'true');
    this.microfrontContainer.clear();

    try {
      const { KeyOptionsOverpaymentComponent } = await loadRemoteModule({
        type: 'module',
        remoteEntry: environment.SECURITY_REMOTE_ENTRY_URL,
        exposedModule: './VALIDACION_COMPONENT',
      });

      this.microfrontContainer.createComponent(KeyOptionsOverpaymentComponent);
    } catch (error) {
      console.error('Error al cargar el microfront remoto:', error);
    }
  }

  public async descargarCertificado() {
    this.loading = true;
    try {
      await this.certificadoOfertaService.descargarCertificadoOferta();

      this.pasoActual = 4;
      this.descargaCertificadoStepper.setStepCurrent(this.pasoActual + 1); // Stepper considera n+1 para marcar completo
      this.loading = false;
      this.errorServiceDescargaCertificado = false;
    } catch (error) {
      this.errorServiceDescargaCertificado = true;
      this.loading = false;
      this.attempt = false;
      if (this.nAttempts === 3)
        await this.onGoToInicioTramite()
      console.error('Error al descargar certificado:', error);
    }
  }

  public goToPerfil() {
    this.router.navigate([DATA_UPDATE, HOME_URL, PROFILE]);
    this.modalCtrl.dismiss();
    this.pasoActual = 1;
    this.descargaCertificadoStepper.setStepCurrent(this.pasoActual);
  }

  async reintentarErrorDescarga() {
    this.attempt = true;
    this.nAttempts++;
    if (this.nAttempts <= 3) await this.descargarCertificado();
  }

  async onGoToInicioTramite() {
    this.pasoActual = 1;
    this.descargaCertificadoStepper.setStepCurrent(this.pasoActual);
  }
  get getVigenciaCertificado(): string {
    return `${DIAS_VIGENCIA_CERTIFICADO_OFERTAS} días hábiles`;
  }
  goToVideAtencion() {
    this.router.navigate(['video-atencion']);
    this.modalCtrl.dismiss();
    this.pasoActual = 1;
    this.descargaCertificadoStepper.setStepCurrent(this.pasoActual);

  }
}

